import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, IconsModule, ProductsModule, UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { DirectiveModule, PipesModule } from '@fcom/common/';
import { ComponentsModule } from '@fcom/common/components';
import { GtmModule } from '@fcom/common/gtm';
import { FinFormsModule } from '@fcom/common/forms';
import { CmsModule } from '@fcom/cms/components/cms.module';
import { BookingCommonModule } from '@fcom/booking/modules/common/booking-common.module';

import { CommonBookingComponentsModule } from '../../common-booking.module';
import {
  AdditionalInfoComponent,
  AncillaryBundleSelectionComponent,
  AncillaryPriceComponent,
  AncillarySelectionComponent,
  CommonProductSelectionComponent,
  MealDetailsComponent,
  ProductListComponent,
  SeatDetailsComponent,
} from './components';
import { TabsModule } from '../tabs';
import { AncillarySubviewModule } from './components/ancillary-subview/ancillary-subview.module';
import { ProductExpandComponent } from './components/product-expand/product-expand.component';
import { SeatPreSelectionComponent } from './components/seat-map/seat-pre-selection/seat-pre-selection.component';
import { SeatMapViewComponent } from './components/seat-map/seat-map-view/seat-map-view.component';
import { SeatPassengersComponent } from './components/seat-map/seat-passengers/seat-passengers.component';
import { SeatMapRendererComponent } from './components/seat-map/seat-map-renderer/seat-map-renderer.component';
import { SeatMapMiniMapComponent } from './components/seat-map/seat-map-mini-map/seat-map-mini-map.component';
import { SeatMapSeatChipsComponent } from './components/seat-map/seat-map-seatchips/seat-map-seatchips.component';
import { GroupedServicesComponent } from './components/grouped-services/grouped-services.component';
import { IncludedServiceComponent } from './components/included-service/included-service.component';
import { IncludedProductHeadingComponent } from './components/included-product-heading/included-product-heading.component';
import { IncludedProductsComponent } from './components/included-products/included-products.component';
import { IncludedTicketsComponent } from './components/included-tickets/included-tickets.component';
import { UpsellCardComponent } from './components/upsell-card/upsell-card.component';
import { InformationModalComponent } from './components/information-modal/information-modal.component';
import { IncludedProductItemComponent } from './components/included-product-item/included-product-item.component';
import { IncludedProductItemSummaryComponent } from './components/included-product-item-summary/included-product-item-summary.component';
import { IncludedProductItemSummarySeatComponent } from './components/included-product-item-summary-seat/included-product-item-summary-seat.component';
import { IncludedProductItemSummaryOtherComponent } from './components/included-product-item-summary-other/included-product-item-summary-other.component';
import { SeatBenefitComponent } from './components/seat-map/seat-benefit/seat-benefit.component';
import { BundleInfoHeaderComponent } from './components/ancillary-bundle-selection/bundle-info-header/bundle-info-header.component';
import { BundleOfferCardComponent } from './components/ancillary-bundle-selection/bundle-offer-card/bundle-offer-card.component';
import { BundleServiceCardComponent } from './components/ancillary-bundle-selection/bundle-service-card/bundle-service-card.component';
import { BundlePromotionCardComponent } from './components/seat-map/bundle-promotion-card/bundle-promotion-card.component';
import { ProductInfoModalComponent } from './components/product-info-modal/product-info-modal.component';

const COMPONENTS = [
  ProductListComponent,
  SeatDetailsComponent,
  AncillarySelectionComponent,
  AncillaryPriceComponent,
  MealDetailsComponent,
  AdditionalInfoComponent,
  CommonProductSelectionComponent,
  AncillaryBundleSelectionComponent,
  BundleInfoHeaderComponent,
  BundleOfferCardComponent,
  BundleServiceCardComponent,
  ProductExpandComponent,
  SeatBenefitComponent,
  BundlePromotionCardComponent,
  ProductInfoModalComponent,
  SeatPreSelectionComponent,
  SeatMapViewComponent,
  SeatPassengersComponent,
  SeatMapRendererComponent,
  SeatMapMiniMapComponent,
  SeatMapSeatChipsComponent,
  GroupedServicesComponent,
  IncludedServiceComponent,
  IncludedProductHeadingComponent,
  IncludedProductsComponent,
  IncludedTicketsComponent,
  UpsellCardComponent,
  InformationModalComponent,
  IncludedProductItemComponent,
  IncludedProductItemSummaryComponent,
  IncludedProductItemSummarySeatComponent,
  IncludedProductItemSummaryOtherComponent,
];

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ComponentsModule,
    PipesModule,
    GtmModule,
    IconsModule,
    ProductsModule,
    UiTranslateModule,
    AncillarySubviewModule,
    TabsModule,
    FinFormsModule,
    UiComponentsModule,
    CommonBookingComponentsModule,
    CmsModule,
    BookingCommonModule,
    DirectiveModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CommonBookingAncillariesModule {}
